<template>
     <ion-page>
      <img :src="`/assets/${background_image}`" class="custom-background" alt="background"  />
      <ion-content class="gradient-background"  :fullscreen="true">
        <ion-grid >
          <ion-row class="ion-justify-content-center separate-top">
            <ion-col  size="12"  size-xl="4">

              <ion-card>
                <ion-card-header class="ion-text-center">
                  <div>
                    <img src="@/assets/logo_2.png" alt="logo" width="250" />
                  </div>
                </ion-card-header>

                <ion-card-content>                  
                  <ion-input
                    class="ion-margin-bottom"  
                    v-model="username" 
                    label="Ingrese el DNI/CIF" 
                    label-placement="floating">
                  </ion-input>
                    

                    <ion-input
                      class="ion-margin-bottom" 
                      :type="'password'" 
                      v-model="password" 
                      label="Ingrese su Password" 
                      label-placement="floating">
                      </ion-input>                        
                   

                    <ion-button 
                      class="ion-margin-bottom" 
                      expand="block" 
                      @click="makeLogin">
                      Ingresar
                    </ion-button>

                    <div class="touch-area">                        
                      <ion-checkbox label-placement="end" v-model="rememberMe" :checked="rememberMe">Recordar Usuario</ion-checkbox>
                    </div>

                      <p class="ion-text-center" >&copy;  Insecal Inspecci&oacute;n {{ currentDate.getFullYear() }} </p>
                      <div class="touch-area">
                        <p class="text-label ion-text-center"><a href="javascript:void(0);" @click="openModal(true)" >Olvide mi password</a></p>
                      </div>

                </ion-card-content>
              </ion-card>              
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-modal :isOpen="isOpen" >
          <ion-header>
            <ion-toolbar>              
              <h3 class="ion-text-center" >Recuperar Password</h3>
            </ion-toolbar>
          </ion-header>
          <ion-content class="ion-padding">
            <ion-item>
              <ion-input ref="input" type="text" label="Ingrese el DNI/CIF" label-placement="stacked" v-model="dniOrCif"></ion-input>
            </ion-item>
          </ion-content>
          <ion-button :color="'danger'" class="custom-button" @click="openModal(false);" >Cancelar</ion-button>
          <ion-button class="custom-button" :strong="true" @click="confirmRecoveryPassword(dniOrCif);" >Confirmar</ion-button>
        </ion-modal>

        <ion-loading
          :isOpen="loadingData.isOpen"
          :message="loadingData.message"
          duration="0"
        ></ion-loading>
      </ion-content>
    </ion-page>  
  </template>
  
<script lang="ts" setup>
  
import { 
  IonPage,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonGrid, 
  IonRow,
  IonCol, 
  IonButton, 
  IonInput, 
  IonItem,
  IonModal,
  IonHeader,
  IonToolbar,
  onIonViewWillEnter, 
  IonLoading,
  isPlatform,
  IonCheckbox
} from '@ionic/vue';
import { useIonRouter } from '@ionic/vue';
import { ref } from 'vue';
import { useUser } from '@/composables/useUser';

const ionRouter = useIonRouter();
const currentDate = new Date();
const loadingData = ref({message:'',isOpen:false});
const background_image = ref('fondo.jpg');

const isOpen = ref(false);
const input = ref();
const dniOrCif = ref('');
const { 
  username,
  password,
  rememberMe,
  makeLogin,
  recoveryPassword,
  checkIsValidSession,
  checkStoreUser
} = useUser(); 

const openModal = (option:boolean) => {
  dniOrCif.value = '';
  isOpen.value = option;
}

const confirmRecoveryPassword = async (dniOrCif:string) => {
  loadingData.value.isOpen = true;
  loadingData.value.message = 'Enviando email...';
  await recoveryPassword(dniOrCif);
  loadingData.value.isOpen = false;
  openModal(false);
}


onIonViewWillEnter(async () => {
  const userSave = await checkStoreUser();
  if(userSave) {
    username.value = userSave.username;
    password.value = userSave.password;
    rememberMe.value = userSave.rememberme;
  }

  const isValidSession = await checkIsValidSession();
  if((isPlatform('ios') || isPlatform('iphone') || isPlatform('android')) && !isPlatform('mobileweb')){
    background_image.value = 'fondo_mobile.png';
  }  
  if(isValidSession!=null) {
    ionRouter.push('/explotaciones');
  }
});


</script>

<style scoped>
.separate-top {
  margin: calc((80vh - 466px) / 2) auto;
}

.gradient-background {
  --background: none;
  background: linear-gradient(rgba(12, 72, 94, 0.8), rgba(12, 72, 94, 0.8));
  position: relative; /* Mantén los hijos en contexto */
  z-index: 0; /* Asegúrate de que el contenido esté sobre el gradiente */
}

.custom-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover; /* Asegura que la imagen mantenga su proporción */
  z-index: -1; /* Coloca la imagen detrás del contenido */
}

/* Inputs del formulario */
ion-input {
    --padding-start: 15px;
    --padding-end: 15px;
    --min-height: 48px;
    --padding-top: 12px;
    --padding-bottom: 12px;
    --background: #F2F2F2;
    --border-radius: 5px;
    --border-color: #A6A6A6;
    --box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    color: #625b5b;
}

/* Botón principal */
ion-button {
  --background: #4E64A6; /* Azul medio */
  color: #fff;
  --border-radius: 5px;
  --box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* Hover en el botón */
ion-button:hover {
  transform: scale(1.05);
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
  
}

/* Efectos de foco en inputs */
ion-input:focus-within {
  border-color: #0ca8d4;
  box-shadow: 0 0 8px rgba(12, 72, 94, 0.3);
}

/* Pie del formulario */
p.ion-text-center {
  color: #0D0D0D;
  font-size: 14px;
}

a {
  color: #4E64A6;
  text-decoration: none;
}

a:hover {
  color: #8890BF; 
}

/* para los inputs en movil */
:deep(ion-input .native-input) {
  min-height: 48px;
  padding-top: 12px;
  padding-bottom: 12px;
}

.touch-area {
  min-height: 48px;  /* Esto garantiza que el contenedor tenga al menos 48dp (en mdpi son 48px) */
  
  
}

.text-label {
  font-size: 16px; 
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>